exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MuiAccordion-root:before {\n    height: 0 !important;\n}\n.MuiTableCell-root {\n    font-size: 13px !important;\n}", ""]);

